let problem = {
  title: "FAQ",
  sub_1: "If you have questions, you can take a look at",
  sub_2: "the FAQ"
}
export default problem


// WEBPACK FOOTER //
// ./src/assets/lang/zh/new_problem/index.js